import { storageService } from '../services/storageService';
import { navigateTo } from '../services/navigationService';

export const getAuthHeaders = () => {
  const token = storageService.getToken();
  return {
    'Authorization': token ? `Bearer ${token}` : '',
    'Content-Type': 'application/json',
  };
};

export const handleApiError = (error) => {
  if (error.response?.status === 401) {
    storageService.clearAuth();
    navigateTo('/login');
    return 'Session expired. Please login again.';
  }
  return error.response?.data?.message || error.message || 'An error occurred';
};

export const extractQuestionSetId = (res, ignoreId, section = null) => {
  const data = res?.data || {};

  if (Array.isArray(data)) {
    const last = data[data.length - 1];
    if (last) {
      const id = last._id || last.id || last.$oid;
      if (id && typeof id === 'string' && id !== ignoreId) {
        return id;
      }
    }
  }

  const candidates = [
    data.questionSetId,
    data.newQuestionSetId,
    data.newId,
    data.id,
    data._id,
    data.newQuestionSet?._id,
    data.newQuestionSet,
    data.questionSet?._id,
    data.questionSet,
    data.data?.questionSetId,
    data.data?._id,
  ];

  for (let id of candidates) {
    if (!id) continue;
    if (typeof id === 'object') {
      id = id._id || id.id || id.$oid;
    }
    if (typeof id === 'string' && id !== ignoreId) {
      return id;
    }
  }

  if (Array.isArray(data.questionSets)) {
    const last = data.questionSets[data.questionSets.length - 1];
    let id = last && (last._id || last.id || last.$oid);
    if (id && typeof id === 'object') id = id._id || id.id || id.$oid;
    if (typeof id === 'string' && id !== ignoreId) return id;
  }

  // Helper to extract the last question set ID from a section's questionSets array
  const extractFromSection = (sectionData) => {
    if (!sectionData || !Array.isArray(sectionData.questionSets) || sectionData.questionSets.length === 0) return null;
    const lastSet = sectionData.questionSets[sectionData.questionSets.length - 1];
    let id = lastSet._id || lastSet.id || lastSet.$oid;
    if (typeof id === 'object') id = id._id || id.id || id.$oid || (id.toString ? id.toString() : null);
    return id && typeof id === 'string' && id !== ignoreId ? id : null;
  };

  // If a specific section is provided, check it first before iterating all sections
  if (section) {
    if (data.passages?.[section]) {
      const id = extractFromSection(data.passages[section]);
      if (id) return id;
    }
    if (data[section]) {
      const id = extractFromSection(data[section]);
      if (id) return id;
    }
  }

  if (data.passages && typeof data.passages === 'object') {
    for (const key of Object.keys(data.passages)) {
      if (key === section) continue; // already checked above
      const id = extractFromSection(data.passages[key]);
      if (id) return id;
    }
  }

  // Check for direct part/passage keys (Listening: part1-4, Reading: passage1-3)
  const partPassageKeys = ['part1', 'part2', 'part3', 'part4', 'passage1', 'passage2', 'passage3'];
  for (const key of partPassageKeys) {
    if (key === section) continue; // already checked above
    const id = extractFromSection(data[key]);
    if (id) return id;
  }

  return undefined;
};
